export const environment = {
    production: true,
    environmentName: 'LAB',
    keycloak: {
      enable: true,
      authority: 'https://id.dev.trendometer.net',
      redirectUri: 'https://horizon.dev.trendometer.net',
      postLogoutRedirectUri: 'https://id.dev.trendometer.net/logout',
      realm: 'TRENDOMETER_DEV',
      clientId: 'dev-trendometer-fe-horizon-client',
    },
    facebookUrl: "https://facebook-data-api.dev.trendometer.net/api",
    twitterUrl: "https://twitter-data-api.dev.trendometer.net/api",
    instagramUrl: "https://instagram-data-api.dev.trendometer.net/api",
    tiktokUrl: "https://tiktok-data-api.dev.trendometer.net/api",
    youtubeUrl: "https://youtube-data-api.dev.trendometer.net/api",
    redditUrl: "https://reddit-data-api.dev.trendometer.net/api",

    
    DATA_VIZ_URL: "https://viz.dev.trendometer.net",
    SENTIMENT_ANALYZER_URL: "https://sa.dev.trendometer.net"
  };
